// React
import React from 'react';
import { Image } from 'react-bootstrap';
import imageFallback from 'assets/images/image-not-available.png';
// Styles
import './styles.scss';

/**
 * @param {Object} props.item - Bundle product to be display
 * @param {string} props.isSelected - Changes the style if the item is selected (primary color background)
 */
const BundleCustomProduct = (props) => {
    return (
        <div
            className={`bundle-product-container ${props.isSelected ? 'selected' : ''}`}
            onClick={() => props.onClick()}
        >
            <Image
                className="item-img"
                src=""
                width="60"
                heigth="60"
                onError={(evt) => {
                    evt.target.src = imageFallback;
                }}
            />
            <p className="name">{props.item.name}</p>
            <p className="selected-text">{ props.isSelected ? 'Selected' : '' }</p>
        </div>
    );
};

export default BundleCustomProduct;
